import { render, staticRenderFns } from "./PrintAddon.vue?vue&type=template&id=b0f7a850&"
import script from "./PrintAddon.vue?vue&type=script&lang=js&"
export * from "./PrintAddon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports